import { useEffect } from 'react';

import { useDocumentTitle } from 'hooks/document-title';
import { useQueryParams } from 'hooks/query-params';
import ReactGA from 'react-ga4';

import { Error } from './Error';

const Error404 = () => {
  useDocumentTitle('Page not found | Checkmate');

  const [message] = useQueryParams(['message']);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: '404 Page not found',
    });
  }, []);

  return <Error message={message}>404</Error>;
};

export default Error404;
